import Vue from "vue";
import Vuex from "vuex";

import { getVariables } from "@/service/api";

// import Modules
import { auth } from "./modules/auth"
import { posiciones } from "./modules/posiciones"
import { tracking } from "./modules/tracking"
import { documents } from "./modules/documents"

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    variables: [],
    formulas: [],
  },

  mutations: {
    setVariables(state, payload) {
      state.variables = payload;
    },

  },

  getters: {

  },

  actions: {
    async listVariables({ commit }) {
      try {
        const response = await getVariables();
        commit("setVariables", response.data);
      } catch (e) {
        console.error(e);
      }
    },
  },

  modules: {
    auth,
    posiciones,
    tracking,
    documents
  },
});

